import { InsertElementMethod, InsertType, ModuleType, } from 'pathfinder/rules-engine/types';
import _operators from 'pathfinder/rules-engine/targetingRules/_operators';
import { DESKTOP_RULE, F2_RULE, MEDIAWIKI_RULE, MOBILE_RULE, NAMESPACE_0_RULE, NO_ADS_REASONS_PRESENT_RULE, USER_ANON_RULE, } from 'pathfinder/rules-engine/targetingRules/_templates';
export var SponsoredWidgetsSponsoredSitewideLogoConsumptionModuleVariant;
(function (SponsoredWidgetsSponsoredSitewideLogoConsumptionModuleVariant) {
    SponsoredWidgetsSponsoredSitewideLogoConsumptionModuleVariant[SponsoredWidgetsSponsoredSitewideLogoConsumptionModuleVariant["DESKTOP"] = 0] = "DESKTOP";
    SponsoredWidgetsSponsoredSitewideLogoConsumptionModuleVariant[SponsoredWidgetsSponsoredSitewideLogoConsumptionModuleVariant["MOBILE"] = 1] = "MOBILE";
})(SponsoredWidgetsSponsoredSitewideLogoConsumptionModuleVariant || (SponsoredWidgetsSponsoredSitewideLogoConsumptionModuleVariant = {}));
const INSERT_CONFIG_DESKTOP = {
    type: InsertType.Element,
    selectors: [
        {
            selector: '.global-top-navigation__fandom-logo',
            method: InsertElementMethod.Append,
        },
    ],
};
const INSERT_CONFIG_MOBILE = {
    type: InsertType.Element,
    selectors: [
        {
            selector: '.mobile-global-navigation__left',
            method: InsertElementMethod.Append,
        },
    ],
};
const sponsoredWidgetsSponsoredSitewideLogoConsumptionModules = [
    {
        name: 'sponsored-widgets-sponsored-sitewide-logo-consumption-module-desktop',
        type: ModuleType.SponsoredWidgetsSponsoredSitewideLogoConsumptionModule,
        insertConfig: INSERT_CONFIG_DESKTOP,
        config: {
            sponsoredSitewideLogos: [],
            variant: SponsoredWidgetsSponsoredSitewideLogoConsumptionModuleVariant.DESKTOP,
        },
        targeting: _operators.any(_operators.all(USER_ANON_RULE, DESKTOP_RULE, MEDIAWIKI_RULE, NAMESPACE_0_RULE, NO_ADS_REASONS_PRESENT_RULE), _operators.all(USER_ANON_RULE, DESKTOP_RULE, F2_RULE, NO_ADS_REASONS_PRESENT_RULE)),
    },
    {
        name: 'sponsored-widgets-sponsored-sitewide-logo-consumption-module-mobile',
        type: ModuleType.SponsoredWidgetsSponsoredSitewideLogoConsumptionModule,
        insertConfig: INSERT_CONFIG_MOBILE,
        config: {
            sponsoredSitewideLogos: [],
            variant: SponsoredWidgetsSponsoredSitewideLogoConsumptionModuleVariant.MOBILE,
        },
        targeting: _operators.any(_operators.all(USER_ANON_RULE, MOBILE_RULE, MEDIAWIKI_RULE, NAMESPACE_0_RULE, NO_ADS_REASONS_PRESENT_RULE), _operators.all(USER_ANON_RULE, MOBILE_RULE, F2_RULE, NO_ADS_REASONS_PRESENT_RULE)),
    },
];
export default sponsoredWidgetsSponsoredSitewideLogoConsumptionModules;
